export default "__VITE_ASSET__CDEFUizT__"